<template>
  <div class="set-title">
    <el-dialog
        title="国际物流"
        :visible="true"
        @close="handleClose"
        width="460px"
    >
      <el-form label-suffix="：" size="small" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="国际运单号" prop="code">
          <el-input placeholder="请输入国际运单号" v-model="ruleForm.code"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button size="small" type="info" @click="handleClose">取消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Wl",
  props: {
    row: {
      type: Object,
      default: () =>({})
    }
  },
  data(){
    return{
      ruleForm: {
        code: '',
      },
      rules: {
        code: [
          { required: true, message: '请输入国际运单号', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let params = {
            ...this.ruleForm,
          }
          const res = await this.$http.post("system/member",params)
          if(res.code === 200){
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.$options.confirm(true)
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.set-title {
  ::v-deep .el-dialog__header {
    text-align: center;
  }
  ::v-deep .el-dialog__body{
    padding-top: 10px;
  }
  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
  }
  ::v-deep .el-input-number--medium {
    width: 100%;
  }
  ::v-deep .el-input-number.is-without-controls .el-input__inner {
    text-align: left;
  }
}
</style>
